import React from 'react';

import { LinkList } from '../../../../components';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import type { ViewNestedTaxonomiesProps } from '..';

const ViewNestedTaxonomiesComplex: React.FC<Pick<ViewNestedTaxonomiesProps, 'entities' | 'title'>> = (props) => {
  const { entities, title } = props;

  if (entities.size === 0) {
    return null;
  }

  return (
    <>
      {title && (
        <h2>{title}</h2>
      )}
      <LinkList>
        {entities.map((entity) => {
          const taxonomyTerm = entity.toJS();
          const uuid = taxonomyTerm.uuid[0].value;
          const langcode = taxonomyTerm.langcode[0].value;
          const key = `${uuid}:${langcode}`;

          return (
            <LinkList.PrimaryItem
              key={key}
              title={taxonomyTerm.name[0].value}
              subtitle={taxonomyTerm.description[0].processed || ''}
              link={taxonomyTerm.paths[DEFAULT_LANGUAGE]}
            />
          );
        })}
      </LinkList>
    </>
  );
};

export default ViewNestedTaxonomiesComplex;
